import * as types from './types';

const initialState = {
  leadsError: false,
  leadsChartsError: false,
  postingLeads: null,
  postingLeadsCharts: null,
  loadingPostingLeads: false,
  loadingCharts: false,
  hasRendimientoData: false,
  hasRendimientoDataCharts: false
};

function rendimientosReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_POSTING_LEADS:
      return {
        ...state,
        leadsError: false,
        loadingPostingLeads: true
      };
    case types.FETCH_POSTING_LEADS_COMPLETED:
      return {
        ...state,
        postingLeads: action.payload,
        loadingPostingLeads: false,
        hasRendimientoData: true
      };
    case types.FETCH_POSTING_LEADS_FAILED:
      return {
        ...state,
        leadsError: true,
        loadingPostingLeads: false
      };
    case types.FETCH_POSTING_LEADS_CHARTS:
      return {
        ...state,
        leadsChartsError: false,
        loadingCharts: true
      };
    case types.FETCH_POSTING_LEADS_CHARTS_COMPLETED:
      return {
        ...state,
        postingLeadsCharts: action.payload,
        loadingCharts: false,
        hasRendimientoDataCharts: true
      };
    case types.FETCH_POSTING_LEADS_CHARTS_FAILED:
      return {
        ...state,
        leadsChartsError: true,
        loadingCharts: false
      };
    default:
      return state;
  }
}

export { rendimientosReducer };
